export default __webpack_public_path__ + "static/media/go-outside.f89e453b.jpg";